/**
 * External Dependencies
 */
import barba from '@barba/core';
import Controller from './helpers/Controller';

import common from './controllers/common';
import templateHome from './controllers/templateHome';

import AlertComponent from './components/AlertComponent';
import BannerComponent from './components/BannerComponent';
import GalleryComponent from './components/GalleryComponent';
import LanguagesComponent from './components/LanguagesComponent';
import MapComponent from './components/MapComponent';
import MenuComponent from './components/MenuComponent';
import ParticlesComponent from './components/ParticlesComponent';
import MessageComponent from './components/MessageComponent';
import GridComponent from './components/GridComponent';
import GridServicesComponent from './components/GridServicesComponent';
import GridScreensComponent from './components/GridScreensComponent';
import TextImageComponent from './components/TextImageComponent';
import HeroVideoComponent from './components/HeroVideoComponent';
import HeroComponent from './components/HeroComponent';
import BlockquoteComponent from './components/BlockquoteComponent';
import PartnersComponent from './components/PartnersComponent';
import CtaContactComponent from './components/CtaContactComponent';
import PictureComponent from './components/PictureComponent';
import KeypointComponent from './components/KeypointComponent';
import WysiwygComponent from './components/WysiwygComponent';
import CursorComponent from './components/CursorComponent';
import CardCursorComponent from './components/CardCursorComponent';
// import ListComponent from './components/ListComponent';

const modules = [
  common,
  templateHome,
  AlertComponent,
  BannerComponent,
  GalleryComponent,
  LanguagesComponent,
  MapComponent,
  MenuComponent,
  ParticlesComponent,
  MessageComponent,
  GridComponent,
  GridServicesComponent,
  GridScreensComponent,
  TextImageComponent,
  HeroVideoComponent,
  HeroComponent,
  BlockquoteComponent,
  PartnersComponent,
  CtaContactComponent,
  PictureComponent,
  KeypointComponent,
  WysiwygComponent,
  CursorComponent,
  CardCursorComponent,
];
const controller = new Controller(modules);
controller.ready();

// Barba related
barba.hooks.leave(() => {
  controller.fire('destroyed');
});

barba.hooks.beforeEnter(() => {
  window.scrollTop = 0;
  window.scrollTo(0, 0);
});

barba.hooks.afterLeave(data => {
    const hardReload = data.next.container.querySelectorAll('[data-contact-form], [data-map]').length > 0;

    if (hardReload) {
        barba.force(data.next.url.href);
    }
});

barba.hooks.after(() => {
  controller.fire('created');
});

// @note - this will popup a confirmation before leaving the page
// window.onbeforeunload = () => controller.destroy();
